import { environment } from 'projects/portal-ui/src/environments/environment';

export class APIConstants {
  static readonly baseUrl = environment.apiBaseUrl;
  static readonly eligibilityBaseUrl = APIConstants.baseUrl + '/eligibility';
  static readonly eligibilityCompleteBaseUrl =
    APIConstants.baseUrl + '/eligibility/eligibility-complete';
  static readonly payerBenefitManualEntry = APIConstants.eligibilityBaseUrl + '/manualentry';
  static readonly eligibilityBenefitEditUrl = '/edit';
  static readonly eligibilityPatientBaseUrl = '/patients';
  static readonly eligibilityAppointmentBaseUrl = '/appointments';
  static readonly eligibilityGroupBaseUrl = '/groups';
  static readonly eligibilityApiKeyBaseUrl = '/api-keys';
  static readonly connectorApiKeyBaseUrl = '/connectors';
  static readonly eulaBaseUrl = '/eula';
  static readonly featureFlagBaseUrl = '/feature-flag';

  static readonly importAppointments = APIConstants.eligibilityBaseUrl + '/appointments/import';
  static readonly getEligibilityStatus = APIConstants.eligibilityBaseUrl + '/status';
  static readonly getAppointmentById = APIConstants.eligibilityBaseUrl + '/appointments/';
  static readonly getAllAppointment = APIConstants.eligibilityBaseUrl + '/appointments/get-all';
  static readonly downloadAppointments = APIConstants.eligibilityBaseUrl + '/appointments/download';
  static readonly getAllPatients = APIConstants.eligibilityPatientBaseUrl + '/get-all';
  static readonly getAppointmentsSummary =
    APIConstants.eligibilityBaseUrl + '/appointments/summary';
  static readonly updateSyncStatus = APIConstants.eligibilityBaseUrl + '/appointments/request';
  static readonly providers = APIConstants.eligibilityBaseUrl + '/providers';
  static readonly createProviderUrl = APIConstants.eligibilityBaseUrl + '/providers/create';
  static readonly getClaimsHistory = APIConstants.eligibilityBaseUrl + '/patients/claims-history';
  static readonly getCoveragesHistory =
    APIConstants.eligibilityBaseUrl + '/patients/coverages-history';
  static readonly getNewYearBenefitChecks =
    APIConstants.eligibilityBaseUrl + '/patients/new-year-checks';
  static readonly getEligibilityLogs = '/logs';
  static readonly getRecentEligibilityLogs = '/logs/recent';
  static readonly getInsuranceDetails = APIConstants.eligibilityBaseUrl + '/patients/overview';
  static readonly payerCredentials = APIConstants.eligibilityBaseUrl + '/payer-credentials';
  static readonly managedPayerCredentials =
    APIConstants.eligibilityBaseUrl + '/payer-credentials/zync/managed';
  static readonly submitPayerCredential2FA = `2fa`;
  static readonly updateScheduleSetting =
    APIConstants.eligibilityBaseUrl + '/administration/schedule-settings';
  static readonly getScheduleSetting =
    APIConstants.eligibilityBaseUrl + '/administration/schedule-settings';
  static readonly getTimezones = APIConstants.eligibilityBaseUrl + '/administration/timezones';
  static readonly checkPatientEligibility = APIConstants.eligibilityBaseUrl + '/check-eligibility';

  static readonly getAllPayers = APIConstants.eligibilityBaseUrl + '/payers';
  static readonly getAllAvailablePayers =
    APIConstants.eligibilityBaseUrl + '/providers/payers/available';
  static readonly getAllEnhancedPayers = APIConstants.eligibilityBaseUrl + '/payers/enhanced';
  static readonly getExtraSteps = APIConstants.eligibilityBaseUrl + '/payers/extra-steps';
  static readonly getProcedureCode = APIConstants.eligibilityBaseUrl + '/procedure-code';
  static readonly defaultProvider = APIConstants.eligibilityBaseUrl + '/providers/default';
  static readonly updateProvider = APIConstants.eligibilityBaseUrl + '/providers/update';
  static readonly tags = APIConstants.eligibilityBaseUrl + '/appointments/tags';
  static readonly getAllDXCPortals = APIConstants.eligibilityBaseUrl + '/payers/dxc-portals';

  static readonly createAppointment = APIConstants.eligibilityBaseUrl + '/appointments';
  static readonly updateAppointment = APIConstants.eligibilityBaseUrl + '/appointments/';
  static readonly reSyncEligibilityOfAppointment = APIConstants.eligibilityBaseUrl + '/resync';
  static readonly getGroupInfo =
    APIConstants.eligibilityBaseUrl + APIConstants.eligibilityGroupBaseUrl + '/info';
  static readonly getAllIntegrators =
    APIConstants.eligibilityBaseUrl + APIConstants.eligibilityApiKeyBaseUrl + '/integrators';
  static readonly getAllKeys =
    APIConstants.eligibilityBaseUrl + APIConstants.eligibilityApiKeyBaseUrl;
  static readonly getKeyById =
    APIConstants.eligibilityBaseUrl + APIConstants.eligibilityApiKeyBaseUrl;
  static readonly createKey =
    APIConstants.eligibilityBaseUrl + APIConstants.eligibilityApiKeyBaseUrl;
  static readonly getConnectorLatestConfig =
    APIConstants.eligibilityBaseUrl + APIConstants.connectorApiKeyBaseUrl + '/latest';
  static readonly registerGroup =
    APIConstants.eligibilityBaseUrl + APIConstants.connectorApiKeyBaseUrl + '/register';
  static readonly unregisterGroup =
    APIConstants.eligibilityBaseUrl + APIConstants.connectorApiKeyBaseUrl + '/unregister';
  static readonly getOpenDentalClinics =
    APIConstants.eligibilityBaseUrl + APIConstants.connectorApiKeyBaseUrl + '/open-dental-clinics';
  static readonly checkUserEulaAgreement =
    APIConstants.eligibilityBaseUrl + APIConstants.eulaBaseUrl + '/check';
  static readonly acceptOrDeclineEulaLicense =
    APIConstants.eligibilityBaseUrl + APIConstants.eulaBaseUrl;
  static readonly getEligibilityRunCount =
    APIConstants.eligibilityBaseUrl + '/administration/billing/usage';
  static readonly downloadEligibilityRunCountData =
    APIConstants.eligibilityBaseUrl + '/administration/billing/usage/download';
  static readonly testCloudConnectorConnection =
    APIConstants.eligibilityBaseUrl +
    APIConstants.eligibilityApiKeyBaseUrl +
    '/integrator/test-connection';
  static readonly updateEligibilityStatusOverride =
    APIConstants.eligibilityBaseUrl + '/override/eligibility-status';
  static readonly deleteEligibilityStatusOverride =
    APIConstants.eligibilityBaseUrl + '/override/eligibility-status';
  static readonly updateInsuranceStatusOverride =
    APIConstants.eligibilityBaseUrl + '/override/insurance-status';
  static readonly deleteInsuranceStatusOverride =
    APIConstants.eligibilityBaseUrl + '/override/insurance-status';

  static readonly externalApiEmbedBaseUrl = environment.apiIntegrationBaseUrl + '/embed';
  static readonly externalApiEmbedProviders = APIConstants.externalApiEmbedBaseUrl + '/provider';
  static readonly externalApiEmbedAvailablePayers =
    APIConstants.externalApiEmbedBaseUrl + '/provider/payers/available';
  static readonly externalApiEmbedCreateProvider =
    APIConstants.externalApiEmbedBaseUrl + '/provider/create';
  static readonly externalApiEmbedUpdateProvider =
    APIConstants.externalApiEmbedBaseUrl + '/provider/update';
  static readonly externalApiEmbedsetDefaultProvider =
    APIConstants.externalApiEmbedBaseUrl + '/provider/default';
  static readonly externalApiEmbedDefaultProvider =
    APIConstants.externalApiEmbedBaseUrl + '/provider/default';
  static readonly externalApiEmbedNewYearBenefitChecks =
    APIConstants.externalApiEmbedBaseUrl + '/patients/new-year-checks';
  static readonly embedEligibilityValidateToken =
    APIConstants.externalApiEmbedBaseUrl + '/token/validate';
  static readonly embedEligibilityRefreshToken =
    APIConstants.externalApiEmbedBaseUrl + '/token/refresh';
  static readonly externalApiEmbedAppointments =
    APIConstants.externalApiEmbedBaseUrl + '/appointments';
  static readonly externalApiEmbedEligibility =
    APIConstants.externalApiEmbedBaseUrl + '/eligibility';
  static readonly externalApiEmbedPatients = APIConstants.externalApiEmbedBaseUrl + '/patients';
  static readonly externalApiEmbedProcedureCode =
    APIConstants.externalApiEmbedBaseUrl + '/procedure-code';
  static readonly externalApiEmbedPayers = APIConstants.externalApiEmbedBaseUrl + '/payers';
  static readonly payerCredPageFeatureCheck = APIConstants.featureFlagBaseUrl + '/payer-credential';
  static readonly newYearBenefitChecksFeatureCheck =
    APIConstants.featureFlagBaseUrl + '/new-year-benefit-checks';
  static readonly externalApiEmbedPayerCredential =
    APIConstants.externalApiEmbedBaseUrl + '/payer-credential';
  static readonly externalApiEmbedCheckPayerCredentialAllowed =
    APIConstants.externalApiEmbedBaseUrl + '/check';
  static readonly externalApiEmbedCheckNewYearBenefitChecksAllowed =
    APIConstants.externalApiEmbedBaseUrl + '/feature-flag/new-year-benefit-checks';
  static readonly externalApiEmbedGetExtraSteps =
    APIConstants.externalApiEmbedBaseUrl + '/extra-steps';
  static readonly externalApiEmbedGetAppointmentsSummary =
    APIConstants.externalApiEmbedBaseUrl + '/summary';
  static readonly externalApiEmbedGetAllAppointment =
    APIConstants.externalApiEmbedBaseUrl + '/get-all';
  static readonly externalApiEmbedProvider = APIConstants.externalApiEmbedBaseUrl + '/provider';
  static readonly externalApiEmbedGetGroupInfo = APIConstants.externalApiEmbedBaseUrl + '/info';
  static readonly externalApiEmbedReSyncEligibilityOfAppointment =
    APIConstants.externalApiEmbedBaseUrl + '/resync';
  static readonly externalApiEmbedCreateAppointment =
    APIConstants.externalApiEmbedBaseUrl + '/appointments';
  static readonly externalApiEmbedUpdateAppointment =
    APIConstants.externalApiEmbedBaseUrl + '/appointments/';
  static readonly externalApiEmbedUpdateEligibilityStatusOverride =
    APIConstants.externalApiEmbedEligibility + '/override/eligibility-status';
  static readonly externalApiEmbedDeleteEligibilityStatusOverride =
    APIConstants.externalApiEmbedEligibility + '/override/eligibility-status';
  static readonly externalApiEmbedUpdateInsuranceStatusOverride =
    APIConstants.externalApiEmbedEligibility + '/override/insurance-status';
  static readonly externalApiEmbedDeleteInsuranceStatusOverride =
    APIConstants.externalApiEmbedEligibility + '/override/insurance-status';
  static readonly externalApiEmbedUpdateSyncStatus =
    APIConstants.externalApiEmbedBaseUrl + '/appointments/request';
  static readonly externalApiEmbedDownloadAppointments =
    APIConstants.externalApiEmbedBaseUrl + '/appointments/download';
  static readonly externalApiEmbedTags =
    APIConstants.externalApiEmbedBaseUrl + '/appointments/tags';

  static readonly eligibilityCompleteRequest = APIConstants.eligibilityCompleteBaseUrl + '/request';
  static readonly addQuestionToCompleteRequestUrl = (requestId: number) =>
    APIConstants.eligibilityCompleteRequest + `/${requestId}` + '/add-question';
  static readonly updateQuestionToCompleteRequestUrl = (requestId: number) =>
    APIConstants.eligibilityCompleteRequest + `/${requestId}` + '/update-question';
  static readonly deleteQuestionToCompleteRequestUrl = (requestId: number) =>
    APIConstants.eligibilityCompleteRequest + `/${requestId}` + '/delete-question';
  static readonly getDefaultQuesitonsByField =
    APIConstants.eligibilityCompleteBaseUrl + '/get-default-questions-by-field';
  static readonly getCompleteRequestById = (requestId: number) =>
    APIConstants.eligibilityCompleteRequest + `/${requestId}`;
  static readonly deleteCompleteRequestById = (requestId: number) =>
    APIConstants.eligibilityCompleteRequest + `/${requestId}`;
  static readonly updateEligibilityCompletePriority = (requestId: number) =>
    APIConstants.eligibilityCompleteRequest + `/${requestId}/update-priority`;
  static readonly updateEligiCompleteProviderParticipation = (requestId: number) =>
    APIConstants.eligibilityCompleteRequest + `/${requestId}/update-provider-participation`;
  static readonly submitEligCompleteRequest = (requestId: number) =>
    APIConstants.eligibilityCompleteRequest + `/${requestId}/submit-to-queue`;
  static readonly deleteEligCompleteRequest = (requestId: number) =>
    APIConstants.eligibilityCompleteRequest + `/${requestId}`;
  static readonly eligibilityCompleteTemplateBaseUrl =
    APIConstants.eligibilityBaseUrl + '/eligibility-complete-template';
  static readonly getEligCompleteRequestsList = APIConstants.eligibilityCompleteRequest;
  static readonly acceptAnswerById = (requestId: number) =>
    `${APIConstants.eligibilityCompleteRequest}/${requestId}/accept-answer`;
  static readonly acceptAllAnswers = (requestId: number) =>
    `${APIConstants.eligibilityCompleteRequest}/${requestId}/accept-all-answers`;
  static readonly getPayerList = APIConstants.baseUrl + '/public/payerlist';
  static readonly getPayerListExport = APIConstants.baseUrl + '/public/payerlist/export';
  static readonly updateGroupName =
    APIConstants.eligibilityBaseUrl + APIConstants.eligibilityGroupBaseUrl + '/name';
  static readonly createEligibilityCompleteTemplate =
    APIConstants.eligibilityCompleteTemplateBaseUrl + '/template';
  static readonly getSandboxData = APIConstants.eligibilityBaseUrl + '/sandbox';
  static readonly getEligCompleteTemplatesList =
    APIConstants.eligibilityCompleteTemplateBaseUrl + '/templates';
  static readonly getTemplateById = (templateId: number) =>
    APIConstants.eligibilityCompleteTemplateBaseUrl + `/template/${templateId}`;
  static readonly updateTemplate = (templateId: number) =>
    APIConstants.eligibilityCompleteTemplateBaseUrl + `/template/${templateId}`;
  static readonly deleteTemplateQuestion = (templateId: number, questionId: number) =>
    APIConstants.eligibilityCompleteTemplateBaseUrl + `/template/${templateId}/${questionId}`;
  static readonly addQuestionToTemplatetUrl = (templateId: number) =>
    APIConstants.eligibilityCompleteTemplateBaseUrl + `/template/${templateId}` + '/question';
  static readonly cancelRetryById = APIConstants.eligibilityBaseUrl + '/retry/';
  static readonly embedCancelRetryById = APIConstants.externalApiEmbedEligibility + '/retry/';
  static readonly groupMfaSettings =
    APIConstants.eligibilityBaseUrl + '/administration/mfa-settings';
  static readonly groupMfa = APIConstants.eligibilityBaseUrl + '/administration/mfa';
  static readonly groupMfaEmbed = APIConstants.externalApiEmbedPayerCredential + '/mfa';
  static readonly groupMfaSettingsEmbed =
    APIConstants.externalApiEmbedPayerCredential + '/mfa-settings';
  static readonly getAllDXCPortalsEmbed = APIConstants.externalApiEmbedBaseUrl + '/dxc-portals';
}
